<template>
  <v-theme-provider>
    <v-app
      id="v-app"
      app
    >
      <v-img
        height="100vh"
        cover
        :src="background"
      >
        <v-row
          no-gutters
          style="max-height: 100vh; overflow-y: auto; overflow-x: hidden; flex-grow: 1"
        >
          <v-col cols="3" />
          <v-col cols="6">
            <v-row style="height: 15vh" />
            <v-row
              no-gutters
              style="max-height: 85vh; overflow-y: auto; overflow-x: hidden; flex-grow: 1"
            >
              <v-col
                align="center"
                cols="12"
              >
                <v-card
                  max-width="420px"
                  max-height="650px"
                  variant="elevated"
                  hover
                >
                  <v-card-title align="center">
                    Polteq ID - {{ i18n.t('app.title') }} <br>
                    <v-avatar density="comfortable">
                      <img
                        height="32"
                        width="32"
                        alt="polteq-id logo"
                        :src="require('@/assets/polteq_id.png')"
                      >
                    </v-avatar>
                  </v-card-title>
                  <v-card-subtitle>
                    <router-link
                      :style="i18n.locale.value !== 'nl' ? 'text-decoration: none !important;' : ''"
                      to=""
                      @click="setLocale('nl')"
                    >
                      NL
                    </router-link>
                    |
                    <router-link
                      :style="i18n.locale.value !== 'en' ? 'text-decoration: none !important;' : ''"
                      to=""
                      @click="setLocale('en')"
                    >
                      EN
                    </router-link>
                  </v-card-subtitle>
                  <v-divider
                    opacity="100"
                    :thickness="1"
                    color="success"
                  />
                  <div style="max-height: 450px">
                    <SignUpForm v-if="navigationStore.form === Forms.SIGN_UP" />
                    <ForgotPasswordForm v-else-if="navigationStore.form === Forms.FORGOT_PASSWORD" />
                    <ChangePasswordForm v-else-if="navigationStore.form === Forms.CHANGE_PASSWORD" />
                    <ResetPasswordForm v-else-if="navigationStore.form === Forms.RESET_PASSWORD" />
                    <PersonalProfile v-else-if="navigationStore.form === Forms.PROFILE" />
                    <SelectServiceForm v-else-if="navigationStore.form === Forms.SERVICES" />
                    <IDOverview v-else-if="navigationStore.form === Forms.SIGNED_IN" />
                    <ActivateForm v-else-if="navigationStore.form === Forms.ACTIVATE" />
                    <SignInForm v-else />
                  </div>
                  <v-divider
                    opacity="100"
                    :thickness="1"
                    color="success"
                  />
                  <v-card-text align="right">
                    <PolteqButton
                      v-if="
                        navigationStore.form === '' ||
                          navigationStore.form === Forms.SIGN_IN ||
                          navigationStore.form === Forms.ACTIVATE ||
                          navigationStore.form === Forms.RESET_PASSWORD ||
                          navigationStore.form === Forms.FORGOT_PASSWORD
                      "
                      button-id="goToCreateAccountButton"
                      icon="mdi-account-plus-outline"
                      :button-text="i18n.t('texts.newuser')"
                      @click="NavigationHelper.openForm(router, Forms.SIGN_UP)"
                    />
                    <PolteqButton
                      v-if="navigationStore.form === Forms.SIGN_UP"
                      button-id="goHomeButton"
                      icon="mdi-home-outline"
                      :button-text="i18n.t('texts.homepage')"
                      @click="NavigationHelper.openForm(router, Forms.SIGN_IN)"
                    />
                    <PolteqButton
                      v-if="
                        navigationStore.form === Forms.SERVICES ||
                          navigationStore.form === Forms.PROFILE ||
                          navigationStore.form === Forms.CHANGE_PASSWORD
                      "
                      button-id="goToAccountButton"
                      icon="mdi-skip-backward-outline"
                      :button-text="i18n.t('texts.toaccount')"
                      @click="NavigationHelper.openForm(router, Forms.SIGNED_IN)"
                    />
                    <br v-if="navigationStore.form !== Forms.SIGN_IN && navigationStore.form !== Forms.SIGNED_IN">
                    <PolteqButton
                      v-if="userStore.userInfo.email !== ''"
                      button-id="logoutButton"
                      icon="mdi-logout"
                      :button-text="i18n.t('buttons.signout') + ' ' + userStore.userInfo.preferredUsername"
                      @click="AuthenticationHelper.logout(router)"
                    />
                    <PolteqButton
                      v-if="
                        navigationStore.form === Forms.SIGN_UP ||
                          navigationStore.form === Forms.ACTIVATE ||
                          navigationStore.form === Forms.RESET_PASSWORD ||
                          navigationStore.form === Forms.FORGOT_PASSWORD
                      "
                      button-id="existingUserButton"
                      icon="mdi-login"
                      :button-text="i18n.t('texts.existinguser')"
                      @click="NavigationHelper.openForm(router, Forms.SIGN_IN)"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <div style="max-height: 100vh; overflow-y: auto; overflow-x: hidden; flex-grow: 1">
              <TimeOutAlert
                v-for="notificationMessage of portalStateStore.notificationMessages"
                :key="notificationMessage.uuid"
                :notification-message="notificationMessage"
              />
            </div>
            <div style="max-height: 100vh; overflow-y: auto; overflow-x: hidden; flex-grow: 1">
              <TimeOutAlert
                v-for="notificationMessage of portalStateStore.notificationMessages"
                :key="notificationMessage.uuid"
                :notification-message="notificationMessage"
              />
            </div>
          </v-col>
        </v-row>
      </v-img>
    </v-app>
  </v-theme-provider>
</template>

<script lang="ts" src="./UserPortal.ts" />
<style lang="scss" src="./polteq.scss" />
